/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_ExpiredInputs */

const en_cc_expired = /** @type {(inputs: Cc_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The picker session expired. Restart from the extension icon.`)
};

const id_cc_expired = /** @type {(inputs: Cc_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi pemilih kedaluwarsa. Mulai lagi melalui ikon ekstensi.`)
};

/**
* | output |
* | --- |
* | "The picker session expired. Restart from the extension icon." |
*
* @param {Cc_ExpiredInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_expired = /** @type {((inputs?: Cc_ExpiredInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_ExpiredInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_expired(inputs)
	return en_cc_expired(inputs)
});